document.addEventListener('DOMContentLoaded', () => {
  const investmentInput = document.getElementById('investment_amount'),
    rateInput = document.getElementById('rate_of_interset'),
    timeInput = document.getElementById('time_period'),
    warningMessage = document.getElementById('warning-message');
  (MIN_INVESTMENT = investmentInput.min ? parseInt(investmentInput.min) : 1000),
    (MAX_INVESTMENT = investmentInput.max
      ? parseInt(investmentInput.max)
      : 10000000),
    (MIN_RATE = 1),
    (MAX_RATE = 30),
    (MIN_TIME = 1),
    (MAX_TIME = 30);
  let default_val = investmentInput.placeholder
    ? investmentInput.placeholder.replace(/^0+/, '').replace(/[^0-9]/g, '') ||
      '0'
    : 100000;
  default_val = parseInt(default_val, 10) || 0;

  const DEFAULT_INVESTMENT = default_val;
  let default_rate = rateInput.placeholder
    ? rateInput.placeholder.replace(/^0+/, '').replace(/[^0-9.]/g, '') || '7.5'
    : 7.5;
  default_rate = parseFloat(default_rate, 10) || 0;

  const DEFAULT_RATE = default_rate;

  let default_time = timeInput.placeholder
    ? timeInput.placeholder.replace(/^0+/, '').replace(/[^0-9]/g, '') || '5'
    : 5;
  default_time = parseInt(default_time, 10) || 0;

  const DEFAULT_TIME = default_time;

  const rangeInput = document.getElementById('amount_range'),
    thumbLabel = document.createElement('div');
  thumbLabel.className = 'thumb-label1';
  thumbLabel.innerText = rangeInput.value;
  document.querySelector('.range-slider').appendChild(thumbLabel);

  const updateThumbLabel = () => {
    const rangeWidth = rangeInput.offsetWidth;
    (min = parseInt(rangeInput.min)),
      (max = parseInt(rangeInput.max)),
      (val = parseInt(rangeInput.value)),
      (percentage = ((val - min) / (max - min)) * 100),
      (offset = (percentage / 100) * rangeWidth);
    thumbLabel.style.left = `${offset}px`;
    thumbLabel.innerText = val.toLocaleString('en-IN');
    rangeInput.style.background = `linear-gradient(to right, #00FFCC ${percentage}%, #ccc ${percentage}%)`;
  };

  rangeInput.addEventListener('input', updateThumbLabel);
  rangeInput.addEventListener('change', updateThumbLabel);
  updateThumbLabel();

  function numberToWords(num) {
    if (num === 0) return 'Zero Rupees';

    const belowTwenty = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];

    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ];

    const units = ['', 'Thousand', 'Lakh', 'Crore'];

    function convertLessThanThousand(n) {
      if (n < 20) return belowTwenty[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] +
          (n % 10 !== 0 ? ' ' + belowTwenty[n % 10] : '')
        );
      return (
        belowTwenty[Math.floor(n / 100)] +
        ' Hundred' +
        (n % 100 !== 0 ? ' ' + convertLessThanThousand(n % 100) : '')
      );
    }

    let result = '';
    let unitIndex = 0;

    while (num > 0) {
      let part = num % 1000;
      if (unitIndex === 1) part = num % 100;
      if (part !== 0) {
        result =
          convertLessThanThousand(part) +
          (units[unitIndex] ? ' ' + units[unitIndex] : '') +
          ' ' +
          result;
      }
      num = Math.floor(num / (unitIndex === 1 ? 100 : 1000));
      unitIndex++;
    }

    return result.trim() + ' Rupees';
  }

  const rangeSlider = document.getElementById('amount_range'),
    frequencyButtons = document.querySelectorAll('.frequency-btn'),
    ctx = document.getElementById('myChart'),
    resposniveChart = document
      .getElementById('singleBarChart')
      .getContext('2d');

  investmentInput.addEventListener('input', () => {
    let enteredValue = investmentInput.value.trim();
    if (enteredValue === '') {
      warningMessage.style.display = 'none';
      return;
    }
    let investmentValue = parseFloat(enteredValue.replace(/[^0-9.]/g, ''));
    if (isNaN(investmentValue)) {
      warningMessage.style.display = 'none';
      return;
    }
    if (investmentValue < MIN_INVESTMENT) {
      warningMessage.style.display = 'block';
    } else {
      warningMessage.style.display = 'none';
    }
    rangeInput.value = investmentValue;
    document.getElementById('amount-words').innerText =
      numberToWords(investmentValue);
    updateThumbLabel();
  });

  rangeInput.addEventListener('input', () => {
    warningMessage.style.display = 'none';
    updateThumbLabel();
  });

  let compoundingFrequency = 1;
  let fixedDepositChart;

  const initialValues = window.calculatorCalculation(
    DEFAULT_INVESTMENT,
    DEFAULT_RATE,
    compoundingFrequency,
    5,
  );

  const initChart = (principal, interest) => {
    return new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: '',
            data: [principal, interest],
            backgroundColor: ['#8F65DD', '#E0D5F5'],
            hoverBackgroundColor: ['#8F65DD', '#E0D5F5'],
          },
        ],
      },
      options: {
        responsive: true,
        cutout: '60%',
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const label =
                  context.dataIndex === 0
                    ? `Investment amt.: ₹${context.dataset.data[context.dataIndex].toLocaleString('en-IN')}`
                    : `Total Interest: ₹${Number(context.dataset.data[context.dataIndex].toFixed(0)).toLocaleString('en-IN')}`;
                return label;
              },
            },
          },
        },
      },
      plugins: [
        {
          beforeDraw: function (chart) {
            var ctx = chart.ctx;
            var width = chart.width;
            var height = chart.height;
            var radius = chart.innerRadius;
            var x = width / 2;
            var y = height / 2;
            var textLines = ['Investment amt.', 'Total Interest'];
            var bulletRadius = 6;
            var textOffset = 25;
            var bulletColors = ['#8F65DD', '#E0D5F5'];
            var totalHeight =
              (textLines.length - 1) * textOffset + bulletRadius * 2;

            for (var i = 0; i < textLines.length; i++) {
              var textY = y - totalHeight / 2 + i * textOffset;
              var bulletX = x - 50;
              ctx.save();
              ctx.beginPath();
              ctx.arc(bulletX, textY, bulletRadius, 0, 2 * Math.PI);
              ctx.fillStyle = bulletColors[i];
              ctx.fill();
              ctx.restore();
              ctx.save();
              ctx.font = '16px DM Sans';
              ctx.textAlign = 'left';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#001316';
              ctx.fillText(textLines[i], bulletX + bulletRadius * 2, textY);
              ctx.restore();
            }
          },
        },
      ],
    });
  };

  function reloadChart() {
    if (fixedDepositChart) {
      fixedDepositChart.destroy();
    }

    const profit =
      parseFloat(investmentInput.value.replace(/,/g, '')) || DEFAULT_INVESTMENT;
    (rate_of_interset = parseFloat(rateInput.value) || DEFAULT_RATE),
      (total_amount = parseFloat(timeInput.value.replace(/[^0-9]/g, '')) || 5),
      ({ maturityAmount, interestEarned } = window.window.calculatorCalculation(
        profit,
        rate_of_interset,
        compoundingFrequency,
        total_amount,
      ));
    fixedDepositChart = initChart(maturityAmount, interestEarned);
    document.querySelector(
      '.calculation-content div:nth-child(1) .price',
    ).innerText = `₹ ${maturityAmount.toLocaleString('en-IN')}`;
    document.querySelector(
      '.calculation-content div:nth-child(2) .price',
    ).innerText = `₹ ${Math.round(interestEarned).toLocaleString('en-IN')}`;
    document.querySelector(
      '.calculation-content div:nth-child(3) .price',
    ).innerText =
      `₹ ${Math.round(maturityAmount + interestEarned).toLocaleString('en-IN')}`;
    document.getElementById('amount-words').innerText = numberToWords(profit);
  }

  reloadChart();

  window.addEventListener('resize', reloadChart);

  const data = {
    labels: [''],
    datasets: [
      {
        label: 'Investment amt.',
        data: [initialValues.maturityAmount],
        backgroundColor: '#8F65DD',
        borderRadius: {
          topLeft: 4,
          bottomLeft: 4,
        },
        borderSkipped: false,
      },
      {
        label: 'Total Interest',
        data: [initialValues.interestEarned],
        backgroundColor: '#E0D5F5',
        borderRadius: {
          topRight: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      },
    ],
  };

  const config = {
    type: 'bar',
    data: data,
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          position: 'nearest',
          caretPadding: 10,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          titleFont: { size: 14 },
          bodyFont: { size: 12 },
          yAlign: 'bottom',
          xAlign: 'center',
          callbacks: {
            label: function (context) {
              const label =
                context.dataset.label === 'Investment amt.'
                  ? `Investment amt.: ₹${context.raw.toLocaleString('en-IN')}`
                  : `Total Interest: ₹${context.raw.toLocaleString('en-IN')}`;
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          display: false,
          stacked: true,
        },
        y: {
          display: false,
          stacked: true,
        },
      },
    },
  };

  const singleBarChart = new Chart(resposniveChart, config);

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  const updateChartAndValues = () => {
    profit = clamp(
      parseFloat(investmentInput.value.replace(/,/g, '')) || DEFAULT_INVESTMENT,
      MIN_INVESTMENT,
      MAX_INVESTMENT,
    );
    (rate_of_interset = clamp(
      parseFloat(rateInput.value) || DEFAULT_RATE,
      MIN_RATE,
      MAX_RATE,
    )),
      (total_amount = clamp(
        parseFloat(timeInput.value) || DEFAULT_TIME,
        MIN_TIME,
        MAX_TIME,
      )),
      ({ maturityAmount, interestEarned } = window.window.calculatorCalculation(
        profit,
        rate_of_interset,
        compoundingFrequency,
        total_amount,
      ));
    fixedDepositChart.data.datasets[0].data = [0, 0];
    fixedDepositChart.update('none');
    setTimeout(() => {
      fixedDepositChart.data.datasets[0].data = [
        maturityAmount,
        interestEarned,
      ];
      fixedDepositChart.update();
    }, 500);

    const investmentAmount = maturityAmount,
      interestEarn = interestEarned,
      totalAmount = investmentAmount + interestEarn;
    singleBarChart.data.datasets[0].data = [maturityAmount];
    singleBarChart.data.datasets[1].data = [interestEarned];
    singleBarChart.options.scales.x.max = totalAmount;
    singleBarChart.update();

    document.querySelector(
      '.calculation-content div:nth-child(1) .price',
    ).innerText = `₹ ${maturityAmount.toLocaleString('en-IN')}`;
    document.querySelector(
      '.calculation-content div:nth-child(2) .price',
    ).innerText = `₹ ${Math.round(interestEarned).toLocaleString('en-IN')}`;
    document.querySelector(
      '.calculation-content div:nth-child(3) .price',
    ).innerText = `₹ ${Math.round(totalAmount).toLocaleString('en-IN')}`;
    document.getElementById('amount-words').innerText = numberToWords(profit);
  };

  investmentInput.addEventListener('input', function (event) {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/^0+/, '').replace(/[^0-9]/g, '') || '0';
    inputValue = parseInt(inputValue, 10) || 0;
    const min = MIN_INVESTMENT,
      max = MAX_INVESTMENT;
    if (inputValue < min || inputValue > max) {
      if (inputValue == 0) {
        event.target.value = '';
        updateChartAndValues();
        return;
      }
      if (inputValue < min) {
        event.target.value = inputValue.toLocaleString('en-IN');
        updateChartAndValues();
        return;
      }
      if (inputValue > max) {
        inputValue = max;
      }

      let formattedValue = inputValue.toLocaleString('en-IN');

      event.target.value = formattedValue;
    }
    updateChartAndValues();
    event.target.value = inputValue.toLocaleString('en-IN');
  });
  rateInput.addEventListener('input', function (event) {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    const firstDotIndex = inputValue.indexOf('.');
    if (firstDotIndex !== -1) {
      inputValue =
        inputValue.substring(0, firstDotIndex + 1) +
        inputValue.substring(firstDotIndex + 1).replace(/\./g, '');
    }
    inputValue = inputValue.replace(/^0+(?=\d)/, '');
    if (firstDotIndex !== -1) {
      let parts = inputValue.split('.');
      if (parts[1]?.length > 1) {
        parts[1] = parts[1][0];
      }
      inputValue = parts.join('.');
    }
    event.target.value = inputValue;
    inputValue = parseFloat(inputValue) || 0;
    const min = MIN_RATE,
      max = MAX_RATE;

    if (inputValue < min || inputValue >= max) {
      if (inputValue >= max) {
        event.target.value = max;
      } else {
        event.target.value = '';
      }
    }

    updateChartAndValues();
  });
  timeInput.addEventListener('input', function (event) {
    let inputValue = event.target.value.replace(/\D/g, '');
    if (inputValue === '') {
      event.target.value = '';
      updateChartAndValues();
      return;
    }
    const cursorPosition = investmentInput.selectionStart;
    let parsedValue = parseInt(inputValue, 10) || 0;
    const min = MIN_TIME,
      max = MAX_TIME;
    if (parsedValue < min) {
      parsedValue = '';
    } else if (parsedValue > max) {
      parsedValue = max;
    }
    event.target.value = parsedValue;
    updateChartAndValues();
  });

  frequencyButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      frequencyButtons.forEach((button) => button.classList.remove('active'));
      btn.classList.add('active');

      switch (btn.innerText.toLowerCase()) {
        case 'monthly':
          compoundingFrequency = 12;
          break;
        case 'quarterly':
          compoundingFrequency = 4;
          break;
        case 'half-yearly':
          compoundingFrequency = 2;
          break;
        case 'yearly':
          compoundingFrequency = 1;
          break;
      }
      if (investmentInput.value < MIN_INVESTMENT) {
        investmentInput.value = DEFAULT_INVESTMENT.toLocaleString('en-IN');
      }
      updateChartAndValues();
    });
  });

  rangeSlider.addEventListener('input', (e) => {
    investmentInput.value = parseInt(e.target.value).toLocaleString('en-IN');
    updateChartAndValues();
  });

  investmentInput.addEventListener('blur', function (event) {
    if (event.target.value.trim() === '') {
      event.target.value = DEFAULT_INVESTMENT.toLocaleString('en-IN');
    }
  });
  rateInput.addEventListener('blur', function (event) {
    if (event.target.value.trim() === '') {
      event.target.value = DEFAULT_RATE.toLocaleString('en-IN');
    }
  });
  timeInput.addEventListener('blur', function (event) {
    if (event.target.value.trim() === '') {
      event.target.value = DEFAULT_TIME.toLocaleString('en-IN') + ' Years';
    }
  });
});
